import { DeviceModel } from 'commons/src/constants';
import { emptyAction } from '../../actions';
import { PublicDeviceAction, DeviceActionType } from '../../actions/actions';
import { DeviceSensorDetailsType } from '../../models/commons';

export interface PublicDeviceDataStore {
    loading: boolean;
    error: boolean;
    errorMessage: string;
    deviceType: DeviceModel;
    organizationName?: string;
    organizationLogo?: string;
    segmentName?: string;
    sensorDetails: { [sensor: string]: DeviceSensorDetailsType };
    serialNumber?: string;
    backgroundColor?: string;
}

const initialStore: PublicDeviceDataStore = {
    loading: false,
    error: false,
    errorMessage: '',
    deviceType: 'wavePlus',
    sensorDetails: {},
    backgroundColor: undefined,
};

const publicDeviceDataReducer = (
    store: PublicDeviceDataStore = initialStore,
    action: PublicDeviceAction = emptyAction
): PublicDeviceDataStore => {
    switch (action.type) {
        case DeviceActionType.FetchDeviceDataInit:
            return {
                ...store,
                loading: true,
                backgroundColor: action.payload.backgroundColor,
            };
        case DeviceActionType.FetchDeviceDataSuccess:
            return {
                ...store,
                loading: false,
                ...action.response,
            };
        case DeviceActionType.FetchDeviceDataError:
            return {
                ...store,
                loading: false,
                error: true,
                errorMessage: action.error,
            };
        default:
            return {
                ...store,
            };
    }
};

export default publicDeviceDataReducer;
